import { debounce } from "lodash";
import { ReactNode, useEffect, useState } from "react";
import { Icon } from "../icon/icon";
import { TextInput } from "./textInput";

const handleSearch = (searchFunction: (val: any) => void, query: any) => {
  searchFunction(query);
};

const handleDebouncedSearch = debounce(handleSearch, 800);

export const SearchInput = ({
  searchFunction = () => {},
  placeholder = "Search",
  className = "",
  iconClassName = "",
  inputClassName = "",
  customElement,
  debouncedSearch = true,
  value = "",
}: {
  searchFunction?: (val: string) => void;
  placeholder?: string;
  className?: string;
  iconClassName?: string;
  inputClassName?: string;
  customElement?: ReactNode;
  debouncedSearch?: boolean;
  value?: string;
}) => {
  const [searchParams, setSearchParams] = useState<string>("");
  useEffect(() => {
    setSearchParams(value);
  }, [value]);

  useEffect(() => {
    if (debouncedSearch) {
      handleDebouncedSearch(searchFunction, searchParams);
    }
    // eslint-disable-next-line
  }, [searchParams]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (!debouncedSearch) {
          searchFunction(searchParams);
        }
      }}
      className={`flex !w-full items-center gap-3 !rounded-[16px] border border-grey-200 p-3 ${className} `}
    >
      <TextInput
        placeholder={placeholder}
        hasIcon
        iconSvg="search"
        iconClassName={`text-grey-600 ${iconClassName}`}
        className={`!border-none !border-transparent !bg-transparent !p-0 ${inputClassName}`}
        containerClassName={`!w-full`}
        value={searchParams}
        onChange={(e) => setSearchParams(e.target.value)}
        type={"text"}
        name={"search"}
        onBlur={() => {}}
        onKeyDown={(e) => {
          e.stopPropagation();
        }}
      />

      {!!searchParams && (
        <button
          type="button"
          onClick={(e) => {
            setSearchParams("");
            searchFunction("");
          }}
          className="w-fit"
        >
          <Icon
            svg="circle-close"
            width={20}
            height={20}
            className="text-grey-600"
          />
        </button>
      )}

      {customElement && !searchParams ? (
        <button
          type="submit"
          onClick={(e) => {
            e.stopPropagation();
            searchFunction(searchParams);
          }}
          className="w-fit"
        >
          {customElement}
        </button>
      ) : undefined}
    </form>
  );
};
